import { QueryClient } from '@tanstack/react-query';
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: true,
            retry: 3,
            retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
            staleTime: 5000,
            gcTime: 5 * 60 * 1000,
            refetchInterval: false,
        },
        mutations: {
            retry: 1,
            onError: (error) => {
                console.error('Mutation error:', error);
            },
        },
    },
});
export const queryKeys = {
    health: ['health'],
    batches: {
        all: ['batches'],
        lists: () => [...queryKeys.batches.all, 'list'],
        list: (filters) => [...queryKeys.batches.lists(), filters],
        details: () => [...queryKeys.batches.all, 'detail'],
        detail: (id) => [...queryKeys.batches.details(), id],
        stats: (id) => [...queryKeys.batches.all, 'stats', id],
        allStats: () => [...queryKeys.batches.all, 'allStats'],
        comments: (id) => [...queryKeys.batches.detail(id), 'comments'],
    },
    collections: {
        all: ['collections'],
        lists: () => [...queryKeys.collections.all, 'list'],
        list: (filters) => [...queryKeys.collections.lists(), filters],
        details: () => [...queryKeys.collections.all, 'detail'],
        detail: (id) => [...queryKeys.collections.details(), id],
    },
    dashboard: {
        summary: ['dashboard', 'summary'],
        activity: ['dashboard', 'activity'],
    },
    settings: {
        all: ['settings'],
        detail: () => [...queryKeys.settings.all, 'detail'],
    },
    metrics: {
        all: ['metrics'],
        range: (startDate, endDate, granularity) => [...queryKeys.metrics.all, startDate, endDate, granularity],
    },
    jobs: {
        all: ['jobs'],
        lists: () => [...queryKeys.jobs.all, 'list'],
        list: (filters) => [...queryKeys.jobs.lists(), filters],
        details: () => [...queryKeys.jobs.all, 'detail'],
        detail: (id) => [...queryKeys.jobs.details(), id],
    },
    changes: {
        all: ['changes'],
        lists: () => [...queryKeys.changes.all, 'list'],
        list: (params) => [...queryKeys.changes.lists(), params],
    },
    dataFix: {
        all: ['dataFix'],
        dbRefreshTime: () => ['dataFix', 'dbRefreshTime'],
        cases: () => ['dataFix', 'cases'],
        jobs: (cursor, filters) => ['dataFix', 'jobs', cursor ?? null, filters ?? null],
        dbRefreshHistory: (nextToken) => ['dataFix', 'dbRefreshHistory', nextToken],
        collectionRecords: (params) => ['dataFix', 'collectionRecords', params],
    },
};
export function invalidateCollections() {
    return queryClient.invalidateQueries({
        queryKey: queryKeys.collections.all,
    });
}
export function invalidateBatches() {
    return queryClient.invalidateQueries({
        queryKey: queryKeys.batches.all,
    });
}
export function invalidateDashboard() {
    return queryClient.invalidateQueries({
        queryKey: ['dashboard'],
    });
}
